import { render, staticRenderFns } from "./schoolConfig.vue?vue&type=template&id=ae5996aa&scoped=true"
import script from "./schoolConfig.vue?vue&type=script&lang=js"
export * from "./schoolConfig.vue?vue&type=script&lang=js"
import style0 from "./schoolConfig.vue?vue&type=style&index=0&id=ae5996aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5996aa",
  null
  
)

export default component.exports